import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";

import type { VueIslandConfig } from "@solvari/common-fe/helpers";

import {
  initEmitIframeResize,
  initVueIslands,
} from "@solvari/common-fe/helpers";
import {
  initFontAwesome,
  initSentryRoot,
} from "@solvari/common-fe/integrations";
import { initPrimeVue } from "@solvari/components";

import "@/shared/tailwind.css";

function main() {
  initSentryRoot({ project: "morpheus-fe" });
  initEmitIframeResize();
  initFontAwesome();

  const components = {
    leadForm: () => import("@/affiliates/components/leadForm.ts"),
  } satisfies VueIslandConfig;

  const pinia = createPinia();
  initVueIslands(components, (app) => {
    app.use(pinia);
    app.use(PiniaColada, {});
    initPrimeVue(app);
  });
}

main();
